<template>
    <lni-table
        :id="`${id}_table`"
        :hidePagingActions="true"
        :caption="content?.tableCaption"
        :summary="content?.tableSummary"
        :striped="true"
        :items="items"
        loadState="no-data"
        :columns="columns"
        :sort="{
            index: 'asc',
        }"
    >
        <template
            slot="body"
            slot-scope="props"
        >
            <tr>
                <td class="lni-u-text--center">
                    {{ props.item.index }}
                </td>
                <td class="lni-u-text--left">
                    <button
                        v-if="editable"
                        class="lni-u-text--left lni-u-link-style lni-u-type--xs lni-u-text--underline"
                        @click="editItem(props.index)"
                    >
                        <lni-html-element
                            :id="`${id}_table--assignment-${props.index}`"
                            element="span"
                        />
                    </button>
                    <span v-else>
                        {{ props.item.assignment }}
                    </span>
                </td>
                <td class="lni-u-text--center">
                    {{ props.item.duration }}
                </td>
                <td class="lni-u-text--center">
                    {{ formatNumber(props.item.quantity) }}
                </td>
                <td
                    v-if="editable"
                    class="lni-u-text--center"
                >
                    <button
                        class="lni-u-link-style lni-u-type--xs lni-u-text--underline"
                        @click="removeItem(props.index)"
                    >
                        <lni-html-element
                            :id="`${id}_table--action-${props.index}`"
                            element="span"
                        />
                    </button>
                </td>
            </tr>
        </template>
    </lni-table>
</template>

<script>
import {
    mapGetters,
} from 'vuex';

import {
    formatNumber,
} from '@gov.wa.lni/application.janitorial-workload-calculator/source/logic/helpers';

export default {
    name: 'LniJanitorialJobPlanTable',
    emits: ['edit', 'remove'],
    computed: {
        columns() {
            const result = [
                {
                    source: 'duration',
                    displayText: this.content?.durationText,
                },
                {
                    source: 'quantity',
                    displayText: this.content?.quantityLabel,
                },
            ];
            if (this.editable) {
                result.push({
                    source: 'action',
                    displayText: 'Action',
                    headerClasses: 'lni-u-text--center lni-c-janitorial-job-plan-table__action',
                });
            }

            return this.tableColumns(result);
        },
        ...mapGetters({
            content: 'appState/content',
            tableColumns: 'appState/tableColumns',
        }),
    },
    mounted() {
        if (this.items.length) {
            this.$nextTick(() => {
                this.$store.dispatch(`${this.id}/updateTable`, {
                    oneLni: this.$oneLni,
                }, {
                    root: true,
                });
            });
        }
    },
    methods: {
        formatNumber(number) {
            return formatNumber(number);
        },
        removeItem(index) {
            this.$emit('remove', index);
        },
        editItem(index) {
            this.$emit('edit', index);
        },
    },
};
</script>